interface ErrorMessage {
  errors: Record<string, string[]>;
}

export const parseApiResponseError = (errMessage: string) => {
  const errorParsed: ErrorMessage = JSON.parse(errMessage);

  const formattedErrorMessages = Object.entries(errorParsed.errors).map((el) =>
    el.join(': '),
  );
  return formattedErrorMessages;
};
